
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/d/crate",
      function () {
        return require("private-next-pages/d/crate/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/d/crate"])
      });
    }
  